import React from 'react'
import transparentLogo from '../img/logo-transparent.png'
import {Link} from 'react-router-dom'

const Header =({isOpen})=>(
	<header className={isOpen?"header open":"header"} id="header">
		<h2 className="hidden">Header</h2>

		<div className="logo">
			<a href="/">
				<img src={transparentLogo} alt="Sviatoslav Tokariev's logo"/>
			</a>
		</div>
		<nav className="navigation">
			<h2 className="hidden">Navigation</h2>
			<ul>
				<li>
					<Link to={`/`} className="navigation__link navigation__item navigation__item--home"  title="Home" aria-label="Home">
						<span className="icon--home"></span>
					</Link>
				</li>
				<li>
					<Link to={`/projects`} className="navigation__link navigation__item navigation__item--projects" title="Projects" aria-label="Projects">
						<span className="icon--projects"></span>
					</Link>
				</li>
				<li>
					<Link to={`/blog`}  className="navigation__link navigation__item navigation__item--blog" title="Blog" aria-label="Blog">
						<span className="icon--blog"></span>
					</Link>
				</li>
				<li>
					<Link to={`/contact`}  className="navigation__link navigation__item navigation__item--contact" title="Contact" aria-label="Contact">
						<span className="icon--contact"></span>
					</Link>
				</li>

			</ul>

		</nav>
		<div className="social">
			<h2 className="hidden">Social links</h2>
			<ul>
				<li className="social__link">
					<a href="https://github.com/svtokarevsv" target="_blank" rel="noopener noreferrer" className="icon--github" title="Github" aria-label="Github link">
					</a>
				</li>
				<li className="social__link">
					<a href="https://www.facebook.com/svtokarevsv" target="_blank" rel="noopener noreferrer" className="icon--facebook" title="Facebook"
					   aria-label="Facebook link">
					</a>
				</li>
				<li className="social__link">
					<a href="https://www.linkedin.com/in/tokarievsviatoslav/" target="_blank" rel="noopener noreferrer" className="icon--linkedin" title="Linkedin"
					   aria-label="Linkedin link">
					</a>
				</li>
			</ul>
		</div>
	</header>
)
export default Header;


// WEBPACK FOOTER //
// ./src/components/Header.js